import React from "react";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import RightModal from "../Components/Modals/RightModal/RightModal";
import DepotViewContent from "../Components/Depot";

const DepotView = () => {
  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100">
        <DepotViewContent />
        <RightModal width={70} />
      </div>
    </ViewScroller>
  );
};

export default DepotView;
